import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import PlusIcon from 'assets/icons/icon-plus-box-outline.svg?react';
import MinusIcon from 'assets/icons/icon-minus-box-outline.svg?react';
import professionCases from 'helpers/professionCases';

const PageTitle = styled(Typography)(({ theme }) => ({
  padding: '12px 25px 16px 25px',
  fontSize: 24,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const ContentContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 'calc(100vh - 200px)',
  paddingTop: '20px'
}));

const BenefitsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '15px'
  }
}));

const WrapperLeft = styled('div')(({ theme }) => ({
  flex: 1,
  borderRadius: 15,
  backgroundColor: '#fff',
  border: '2px solid #98d44b',
  [theme.breakpoints.down('md')]: {
    marginBottom: 20
  }
}));

const WrapperRight = styled('div')(() => ({
  flex: 1,
  borderRadius: 15,
  backgroundColor: '#fff',
  border: '2px solid #c4202c'
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  padding: '16px 25px',
  borderBottom: '1px solid #a0a0a0',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  }
}));

const ItemsWrapper = styled('div')(() => ({
  padding: '16px 25px'
}));

const ItemWrapper = styled('div')(() => ({
  paddingLeft: 45,
  position: 'relative',
  marginBottom: 30,
  '& svg': {
    position: 'absolute',
    left: 0,
    top: 0
  }
}));

const BenefitTitle = styled(Typography)(() => ({
  fontSize: 18,
  marginBottom: 5,
  lineHeight: 'normal'
}));

const BenefitDescription = styled(Typography)(({ theme }) => ({
  color: '#717171',
  fontSize: 16
}));

const PlusIconStyled = styled(PlusIcon)(() => ({}));

const MinusIconStyled = styled(MinusIcon)(() => ({}));

const BenefitsSlideComponent = ({ professionInfo, t }) => {
  const advantages = professionInfo?.advantages || [];
  const disadvantages = professionInfo?.disadvantages || [];

  // Hide component if both advantages and disadvantages are empty
  if (!advantages.length && !disadvantages.length) {
    return null;
  }

  return (
    <>
      <PageTitle variant={'h1'}>
        {t('Benefits', professionCases(professionInfo, 'genitive'))}
      </PageTitle>

      <ContentContainer>
        <BenefitsWrapper>
          {advantages.length > 0 && (
            <WrapperLeft>
              <Title variant={'h2'}>
                {t('Benefits', professionCases(professionInfo, 'genitive'))}
              </Title>
              <ItemsWrapper>
                {advantages.map((benefit) => (
                  <ItemWrapper key={benefit._id}>
                    <PlusIconStyled />
                    <BenefitTitle variant="h3">{benefit.name}</BenefitTitle>
                    <BenefitDescription variant="body1">{benefit.description}</BenefitDescription>
                  </ItemWrapper>
                ))}
              </ItemsWrapper>
            </WrapperLeft>
          )}
          {disadvantages.length > 0 && (
            <WrapperRight>
              <Title variant={'h2'}>
                {t('Disadvantages', professionCases(professionInfo, 'genitive'))}
              </Title>
              <ItemsWrapper>
                {disadvantages.map((disadvantage) => (
                  <ItemWrapper key={disadvantage?._id}>
                    <MinusIconStyled />
                    <BenefitTitle variant="h3">{disadvantage.name}</BenefitTitle>
                    <BenefitDescription variant="body1">
                      {disadvantage.description}
                    </BenefitDescription>
                  </ItemWrapper>
                ))}
              </ItemsWrapper>
            </WrapperRight>
          )}
        </BenefitsWrapper>
      </ContentContainer>
    </>
  );
};

export default BenefitsSlideComponent;
